import store from "./store";
import MenuService from "./services/menu.service";
import { actions as AppActions } from "./app.store";
import { types } from "./reducers/sidenav_reducer";

const setSideNav = async (dispatch, payload = {}) => {
  let menuList = [];
  try {
    AppActions.setLoading(true);
    const resp = await MenuService.getAll();
    if (resp.data.success) {
      menuList = resp.data.data && resp.data.data.length ? resp.data.data : [];
    }
    AppActions.setLoading(false);
  } catch (err) {
    if (process.env.NODE_ENV === "development") console.error("Side Menu error catch => ", err);
  }
  payload.sideNavItems = menuList;
  dispatch({ type: types.SET_SIDENAV_ITEMS, payload });
};

const actions = {
  setSideNav,
};

if (store.getState().auth_reducer.authToken) actions.setSideNav(store.dispatch, {});

export { store as default };
export { types, actions };
